var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    {
      staticClass: "table table-hover cell-border",
      attrs: { id: "benner-data-table-vue" },
    },
    [
      _vm._t("default", null, { id: "thead" }),
      _vm._v(" "),
      _vm._t("default", null, { id: "tbody" }),
      _vm._v(" "),
      _vm._t("default", null, { id: "tfloor" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }